import qs from 'qs'
import request from '@/utils/request'
import {
  GetReturnReportItemsReq,
  GetReturnReportSummariesReq,
  ReturnInboundActionResult,
  ReturnInboundSummaryActionReq,
  ReturnReportItem,
  ReturnReportSummary,
  SaveReturnReportReq,
} from './types'

/**
 * RGR02 반품조회 엔드포인트 — 전부 moms-be(2.0). 근거: `ReturnReportController`·`ReturnReportSaveController`·
 * `ReturnInboundRestoreController`·`ReturnInboundPlanResendController`. 입고취소는 GR02 와 공유하는
 * `services/inbound/inboundInquiry` 의 `cancelInbound` 를 쓴다.
 */
export const RETURN_REPORT_URL = '/api/v1/return/inbound-results'
export const RETURN_REPORT_SUMMARY_URL = `${RETURN_REPORT_URL}/summary`
export const RETURN_REPORT_SUMMARY_EXCEL_URL = `${RETURN_REPORT_SUMMARY_URL}/excel`
export const RETURN_REPORT_ITEM_EXCEL_URL = `${RETURN_REPORT_URL}/excel`
export const RETURN_INBOUND_RESTORE_URL = `${RETURN_REPORT_URL}/restore`
export const RETURN_INBOUND_RESEND_URL = `${RETURN_REPORT_URL}/resend`

/** 목록 파라미터는 `key=a&key=b` 로 편다 — 화주명에 쉼표가 들어갈 수 있어 공용 comma 형식을 쓰지 않는다(commonFile/apis.ts 선례). */
const toQuery = (params: object): string => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true })

/** HEAD 조회 — 서버 페이징 없이 전건을 준다. 입고번호·주문번호 다건이 URL 길이를 넘지 않게 본문(POST)으로 보낸다(LOGISPRD-14909). */
export const getReturnReportSummaries = (params: GetReturnReportSummariesReq) =>
  request.post<ApiResponseV2<{ items: ReturnReportSummary[] }>, GetReturnReportSummariesReq>(`${RETURN_REPORT_SUMMARY_URL}/search`, params)

/** ITEM 조회 — HEAD 행 하나의 상세 전건. */
export const getReturnReportItems = (params: GetReturnReportItemsReq) =>
  request.get<ApiResponseV2<{ items: ReturnReportItem[] }>>(`${RETURN_REPORT_URL}?${toQuery(params)}`)

export const saveReturnReport = (body: SaveReturnReportReq) =>
  request.patch<ApiResponseV2<{ affectedRows: number }>, SaveReturnReportReq>(RETURN_REPORT_URL, body)

export const restoreReturnInbound = (body: ReturnInboundSummaryActionReq) =>
  request.post<ApiResponseV2<ReturnInboundActionResult>, ReturnInboundSummaryActionReq>(RETURN_INBOUND_RESTORE_URL, body)

export const resendReturnInboundPlan = (body: ReturnInboundSummaryActionReq) =>
  request.post<ApiResponseV2<ReturnInboundActionResult>, ReturnInboundSummaryActionReq>(RETURN_INBOUND_RESEND_URL, body)
